// Billing lives inside Workspace Settings, but has its own absolute URLs so
// customers can be sent straight to it. `settingsTab` selects the tab in AccountView.
export const billingTabPaths = {
	card: '/billing/index',
	invoices: '/billing/invoices',
	address: '/billing/address',
}

export default [
	{
		path: '/billing',
		redirect: billingTabPaths.card,
	},
	{
		path: billingTabPaths.card,
		name: 'Billing Credit Card',
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'billing']],
			settingsTab: 'card',
		}
	},
	{
		path: billingTabPaths.invoices,
		name: 'Billing Invoices',
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'billing']],
			settingsTab: 'invoices',
		}
	},
	{
		path: billingTabPaths.address,
		name: 'Billing Address',
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'billing']],
			settingsTab: 'address',
		}
	},
]
